export default function getResource(label) {
    const resources = {
        itemsInOrder: 'Articles de la commande',
        itemInOrder: 'Article de la commande',
        viewBasket: 'Voir le panier'
    };

    return resources[label];
}
